var colsWithBlanks = ["af", "eur_af", "gnomad_af", "gnomad_nfe_af", "gnomadg_af", "gnomadg_nfe_af", "max_af"];
var numFilter = function (filter, row) {
    if (row[filter.id] && row[filter.id] !== "") {
        if (filter.value.includes(";") && (filter.value.split(";")[1] !== "" && filter.value.split(";")[1] !== ">" && filter.value.split(";")[1] !== "<")) {
            var filter1 = filter.value.split(";")[0]
            var filter2 = filter.value.split(";")[1]
            var filterLow = filter1.includes("<") ? Number(filter1.split("<")[1]) : Number(filter2.split("<")[1])
            var filterHigh = filter2.includes(">") ? Number(filter2.split(">")[1]) : Number(filter1.split(">")[1])

            if (row[filter.id] < filterLow && row[filter.id] > filterHigh) {
                return (true)
            } else {
                return (false)
            }
        } else if (filter.value.includes("<")) {
            if (row[filter.id] < Number(filter.value.split("<")[1])) {
                return (true)
            } else {
                return (false)
            }
        } else if (filter.value.includes(">")) {
            if (row[filter.id] > Number(filter.value.split(">")[1])) {
                return (true)
            } else {
                return (false)
            }
        } else if (filter.value.includes("=")) {
            if (Number(row[filter.id]) === Number(filter.value.split("=")[1])) {
                return (true)
            } else {
                return (false)
            }
        } else {
            return (true)
        }
    } else {
        return (true)
    }
}
const numArrFilter = function (filter, row) {
    const numArr = row[filter.id].split(',').map(x => Number(x))
    if (row[filter.id] && row[filter.id] !== "") {
        if (filter.value.includes(";") && (filter.value.split(";")[1] !== "" && filter.value.split(";")[1] !== ">" && filter.value.split(";")[1] !== "<")) {
            const filter1 = filter.value.split(";")[0]
            const filter2 = filter.value.split(";")[1]
            const filterLow = filter1.includes("<") ? Number(filter1.split("<")[1]) : Number(filter2.split("<")[1])
            const filterHigh = filter2.includes(">") ? Number(filter2.split(">")[1]) : Number(filter1.split(">")[1])

            if (row[filter.id] < filterLow && row[filter.id] > filterHigh) {
                return (true)
            } else {
                return (false)
            }
        } else if (filter.value.includes("<")) {
            if (numArr.some(x => x < Number(filter.value.split("<")[1]))) {
                return (true)
            } else {
                return (false)
            }
        } else if (filter.value.includes(">")) {
            if (numArr.some(x => x > Number(filter.value.split(">")[1]))) {
                return (true)
            } else {
                return (false)
            }
        } else if (filter.value.includes("=")) {
            if (Number(numArr.some(x => x === Number(filter.value.split("=")[1])))) {
                return (true)
            } else {
                return (false)
            }
        } else {
            return (true)
        }
    } else {
        return (true)
    }
}
var charFilter = function (filter, row) {
    if (row[filter.id] && typeof (row[filter.id]) == 'string') {
        if (filter.value === " ") {
            return (row[filter.id] === null)
        } else {
            return (row[filter.id].toLowerCase().match("^" + filter.value.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1").toLowerCase()) !== null)
            // return (row[filter.id].toLowerCase().includes(filter.value.toLowerCase()))
        }
    } else {
        return (null)
    }
    // Honestly I have no idea why I have to check if row[filter.id] exsists in the line above. Without the check, there's a crash saying that it's empty if you filter column 5 in first SNV table...
    // The column is almost the same as the others and I cannot even put a breakpoint before when debugging. Anyway, works now.
}
var arrFilter = function (filter, row) {
    if (filter.value === null || filter.value.length === 0) {
        return (true)
    } else if (filter.id == 'Variant_Classification' & filter.value.length > 0) {
        var flts = filter.value.map(x => x.toString().toLowerCase())
        var val = row[filter.id].toString().toLowerCase()
        var result = flts.map(x => val.includes(x)).some(value => value === true)
        return (result)
    } else if (filter.value.length > 0) {
        return (filter.value.map(x => x.toString().toLowerCase()).includes(row[filter.id].toString().toLowerCase()))
    } else {
        return (null)
    }
}

var varFilter = function (filter, row) {
    if (row[filter.id] && filter.value !== null && filter.value !== "") {
        if (filter.value === null || filter.value.constructor === Array) {
            return (arrFilter(filter, row))
        } else if (typeof row[filter.id] === "number" || !isNaN(Number(row[filter.id]))) { // checking if number
            return (numFilter(filter, row))
        } else if (typeof (row[filter.id]) == 'string' && row[filter.id]?.split(',').every(x => { return !isNaN(Number(x)) })) { // checking if array of numbers
            return (numArrFilter(filter, row))
        } else {
            return (charFilter(filter, row)) //row[filter.id].split(',').every(x => {return typeof x === 'number'})
        }
    } else {
        if (filter.value === '' || filter.value === ' ' || filter.value === null || filter.value[0] === '') {
            return (true)
        } else if (colsWithBlanks.includes(filter.id) && row[filter.id] === "") {
            return (true)
        } else {
            return (null)
        }
    }
}

export function filterVariants(data, filters) {
    if (!filters || filters.length === 0) {
        return data;
    }

    return data.filter(row =>
        filters.every(filter => varFilter(filter, row) !== false)
    );
}